import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuList from "~/components/Blocks/MenuList";
import TextField from "@mui/material/TextField";
import { GetMemberForm, UpdateAttendance, MemberFormSet } from "~slices/MemberForm";
import DrinkList from "~/components/Blocks/DrinkList";
import SelectPrefectures from "~/components/Atoms/SelectPrefectures";
import SelectDeliveryTime from "~/components/Atoms/SelectDeliveryTime";
import SelectDeliveryDate from "~/components/Atoms/SelectDeliveryDate";
import { formatDate, formatTime } from "~/functions/FormatDate";


const MemberForm = () => {
    const dispatch = useDispatch();
    const member_form_state = useSelector((state) => state.MemberForm);
    const menu_data = member_form_state.menu_data;
    const drink_list = member_form_state.drink_list;
    const party = member_form_state.party;
    const noReturnFlag = useSelector((state) => state.ErrorHandler.no_return_flag);
    
    const party_date = formatDate(new Date(party?.party_date), 'YYYY年MM月DD日');
    const party_start_time = formatTime(new Date(party?.party_date + 'T' + party?.party_start_time));

    const partyDateFormatted = formatDate(new Date(party?.party_date), 'YYYY/MM/DD');

    const history = useHistory();

    const path = history.location.pathname.split("/");
    const attendance_form_token = path[3];

    const [attendance, set_attendance] = useState("1");
    const [selectedMenu, setSelectedMenu] = useState({});
    const [selectedDrink, setSelectedDrink] = useState({});
    const [disabled, setDisabled] = useState(false);
    const [disabledDeliveryDate, setDisabledDeliveryDate] = useState(false);
    const [noAM, setNoAM] = useState(false);
    const [isUnder20, setIsUnder20] = useState(null);

    useEffect(() => {
        dispatch(GetMemberForm({ attendance_form_token: attendance_form_token })).then((data) => {
            if(data.payload.result === 'NG')
            {
                console.log('URL不正or〆切済み');
                if(data.payload.message)
                {
                    alert(data.payload.message);
                } else if (data.payload.error_message)
                {
                    alert(data.payload.error_message);
                }
                window.close();
            }
        });
    }, []);

    useEffect(() => {
        if (noReturnFlag) {
            setDisabled(false);
        }
    }, [noReturnFlag]);


    // ********** PM-01：参加登録画面の関数 ***********************************************
    //値変更
    const onChange = (params) => {
        const { name, value } = params;
        dispatch(MemberFormSet([name, value]));

        if (name === "prefecture")
        {
            checkPrefecture(value);
            checkDeliveryDate(member_form_state.delivery_date, value);
        } else if (name === "delivery_date") {
            checkDeliveryDate(value, member_form_state.prefecture);
        }
    };
    //都道府県チェック
    const checkPrefecture = (prefecture) => {
        switch (prefecture) {
            case "北海道":
            case "福岡県":
            case "佐賀県":
            case "長崎県":
            case "熊本県":
            case "大分県":    
            case "宮崎県":    
            case "鹿児島県":    
            case "沖縄県": 
                // 上記の道県の場合は、お届け日が開催当日に限られる
                dispatch(MemberFormSet(["delivery_date", partyDateFormatted]));
                setDisabledDeliveryDate(true);
                break;
            default:
                setDisabledDeliveryDate(false);
                break;
        }
    };
    //お届け日チェック
    const checkDeliveryDate = (deliveryDate, prefecture) => {
        switch (prefecture) {
            case "青森県":
            case "秋田県":
            case "岡山県":
            case "鳥取県":
            case "島根県":
            case "広島県":
            case "山口県":
            case "徳島県":
            case "香川県":
            case "愛媛県":
            case "高知県":
                // 上記の県かつ、お届け日が開催前日の場合は、お届け時間が午後に限られる
                if (deliveryDate !== partyDateFormatted && deliveryDate !== "") {
                    setNoAM(true);
                    if (member_form_state.delivery_time === "0812") {
                        dispatch(MemberFormSet(["delivery_time", ""]));
                    }
                } else {
                    setNoAM(false);
                }
                break;
            default:
                setNoAM(false);
                break;
        }
    };

    // 年齢確認の値変更
    const handleChangeAge = (e) => {
        setIsUnder20(e.target.value);
    };

    // プラン選択
    const selectMenu = (menu_data) => {
        setSelectedMenu(menu_data);
    };
    // プラン再選択
    const reselectMenu = () => {
        setSelectedMenu({});
        setSelectedDrink({});
    };

    // ドリンクセット選択
    const selectDrink = (drink_group_data) => {
        setSelectedDrink(drink_group_data);
    };
    // ドリンクセット再選択
    const reselectDrink = () => {
        setSelectedDrink({});
    };

    //登録内容を確認
    const HandleSubmit = (e) => {
        e.preventDefault();

        if (attendance === "1") {
            if (Object.keys(selectedMenu).length === 0) {
                alert("プランを選択してください。");
                return;
            }
            if (selectedMenu.present_drink_number > 0 && Object.keys(selectedDrink).length === 0) {
                alert("プレゼントドリンクを選択してください。")
                return;
            }
        }

        dispatch(MemberFormSet(['attendance', attendance]));
        dispatch(MemberFormSet(['menu_id', selectedMenu.menu_id]));
        dispatch(MemberFormSet(['menu_name', selectedMenu.menu_name]));
        dispatch(MemberFormSet(['drink_group_id', selectedDrink?.drink_group_id]));
        dispatch(MemberFormSet(['drink_group_name', selectedDrink?.drink_group_name]));
        
        // PM-02 参加登録内容確認画面へ
        dispatch(MemberFormSet(['confirmation', true]));
    };

    // **********************************************************************************


    // ********** PM-02：参加登録内容確認画面の関数 ***************************************
    // 修正する
    const EditClick = () => {
        // PM-01 参加登録画面に戻る
        dispatch(MemberFormSet(['confirmation', false]));
    };

    // 登録する
    const ConfirmationSubmit = (e) => {
        setDisabled(true);
        e.preventDefault();

        // 登録処理
        dispatch(UpdateAttendance(member_form_state)).then((data) => {
            const result = data.payload.result;
            console.log(result);
            if(result === 'OK')
            {
                dispatch(MemberFormSet(['attendance_deadline_date', data.payload.attendance_deadline_date]));
                // PM-03 参加登録完了画面に切り替える
                dispatch(MemberFormSet(['complete', true]));
            }
            else
            {
                // NGメッセージ表示
                alert(data.payload.message);
                setDisabled(false);
            }
        });
    }

    // **********************************************************************************

    return (
        <React.Fragment>
            {/* PM-01 参加登録画面 */}
            <Grid style={{ display: member_form_state.confirmation || member_form_state.complete ? 'none' : '' }}>
                <Typography variant="h2" align="center">
                    参加フォーム
                </Typography>
                <Container>
                    <form onSubmit={HandleSubmit} style={{ width: "100%" }}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                        >
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Typography variant="h4" gutterBottom component="div" sx={{ mt: 3 }}>
                                    {party?.party_name}
                                </Typography>
                                <Typography variant="h6" gutterBottom component="div" sx={{ mt: 3 }}>
                                    開催日時　{party_date}　{party_start_time}～
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                                    参加者情報
                                </Typography>
                            </Grid>
                            <TextField
                                required
                                type="email"
                                label="メールアドレス"
                                variant="outlined"
                                name="email_address"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 60 }}
                                value={member_form_state.email_address}
                                onChange={(e) => onChange({ name: "email_address", value: e.target.value })}
                            />
                            ※参加登録の更新の際は、登録済みのメールアドレスと同じものを入力してください。
                            <TextField
                                sx={{ mt: 2, mb: 1 }}
                                required
                                select
                                fullWidth
                                label="参加･キャンセル"
                                SelectProps={{
                                    native: true,
                                }}
                                name="attendance"
                                value={attendance}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => set_attendance(e.target.value)}
                            >
                                <option value={"1"}>参加</option>
                                <option value={"2"}>キャンセル</option>
                            </TextField>
                            <TextField
                                required
                                sx={{ mt: 2, mb: 1 }}
                                label="業務上氏名"
                                variant="outlined"
                                name="business_name"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 16 }}
                                value={member_form_state.business_name}
                                onChange={(e) => onChange({ name: "business_name", value: e.target.value })}
                            />

                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                sx={{display: attendance === "1" ? "" : "none"}}
                            >
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                                        送付先情報
                                    </Typography>
                                </Grid>
                                <Typography variant="h6" gutterBottom component="div" sx={{ mt: 3 }}>
                                    お名前
                                </Typography>
                                ※お料理の送付先宛名となりますので、会社名・部門名などは記載しないでください。
                                <Grid style={{display:'inline-flex'}}>
                                    <TextField
                                        required
                                        sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                                        label="姓"
                                        variant="outlined"
                                        name="last_name"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ maxLength: 8 }}
                                        value={member_form_state.last_name}
                                        onChange={(e) => onChange({ name: "last_name", value: e.target.value })}
                                        disabled={attendance !== "1"}
                                    />

                                    <TextField
                                        required
                                        sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                                        label="名"
                                        variant="outlined"
                                        name="first_name"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ maxLength: 8 }}
                                        value={member_form_state.first_name}
                                        onChange={(e) => onChange({ name: "first_name", value: e.target.value })}
                                        disabled={attendance !== "1"}
                                    />
                                </Grid>

                                <Typography variant="h6" gutterBottom component="div" sx={{ mt: 3 }}>
                                    お名前（カナ）
                                </Typography>
                                <Grid style={{display:'inline-flex'}}>
                                    <TextField
                                        required
                                        sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                                        label="セイ　半角カタカナのみ使用できます"
                                        variant="outlined"
                                        name="last_name_kana"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ maxLength: 25, pattern: "^[\uFF66-\uFF9F]+$" }}
                                        value={member_form_state.last_name_kana}
                                        onChange={(e) => onChange({ name: "last_name_kana", value: e.target.value })}
                                        disabled={attendance !== "1"}
                                    />
                                    <TextField
                                        required
                                        sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                                        label="メイ　半角カタカナのみ使用できます"
                                        variant="outlined"
                                        name="first_name_kana"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ maxLength: 25, pattern: "^[\uFF66-\uFF9F]+$" }}
                                        value={member_form_state.first_name_kana}
                                        onChange={(e) => onChange({ name: "first_name_kana", value: e.target.value })}
                                        disabled={attendance !== "1"}
                                    />
                                </Grid>

                                <Typography variant="h6" gutterBottom component="div" sx={{ mt: 3 }}>
                                    電話番号
                                </Typography>
                                <TextField
                                    required
                                    sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                                    label="半角数字とハイフンのみ使用できます"
                                    placeholder="123-4567-8901"
                                    variant="outlined"
                                    name="phone"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 15, pattern: "^[-0-9]*$" }}
                                    value={member_form_state.phone}
                                    onChange={(e) => onChange({ name: "phone", value: e.target.value })}
                                    type="tel"
                                    disabled={attendance !== "1"}
                                />

                                <Typography variant="h6" gutterBottom component="div" sx={{ mt: 3 }}>
                                    住所
                                </Typography>
                                <TextField
                                    required
                                    sx={{ m: 1, fontSize: "1.2rem" }}
                                    label="郵便番号　半角数字のみ使用できます"
                                    placeholder="1234567"
                                    variant="outlined"
                                    name="postal_code"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 7, minLength: 7, pattern: "^[0-9]*$" }}
                                    value={member_form_state.postal_code}
                                    onChange={(e) => onChange({ name: "postal_code", value: e.target.value })}
                                    type="tel"
                                    disabled={attendance !== "1"}
                                />
                                <SelectPrefectures
                                    required
                                    sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                                    value={member_form_state.prefecture}
                                    onChange={(e) => onChange({ name: "prefecture", value: e.target.value })}
                                    InputLabelProps={{ shrink: true }}
                                    disabled={attendance !== "1"}
                                />
                                <TextField
                                    required
                                    sx={{ m: 1, fontSize: "1.2rem" }}
                                    label="市区町村"
                                    placeholder="〇〇市"
                                    variant="outlined"
                                    name="city"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 12 }}
                                    value={member_form_state.city}
                                    onChange={(e) => onChange({ name: "city", value: e.target.value })}
                                    disabled={attendance !== "1"}
                                />
                                <TextField
                                    required
                                    sx={{ m: 1, fontSize: "1.2rem" }}
                                    label="町名・番地"
                                    placeholder="〇〇町〇〇-〇〇"
                                    variant="outlined"
                                    name="address1"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 16 }}
                                    value={member_form_state.address1}
                                    onChange={(e) => onChange({ name: "address1", value: e.target.value })}
                                    disabled={attendance !== "1"}
                                />
                                <TextField
                                    sx={{ m: 1, fontSize: "1.2rem" }}
                                    label="建物名・部屋番号１"
                                    placeholder="〇〇マンション〇〇号室"
                                    variant="outlined"
                                    name="address2"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 16 }}
                                    value={member_form_state.address2}
                                    onChange={(e) => onChange({ name: "address2", value: e.target.value })}
                                    disabled={attendance !== "1"}
                                />
                                <TextField
                                    sx={{ m: 1, fontSize: "1.2rem" }}
                                    label="建物名・部屋番号２"
                                    variant="outlined"
                                    name="address_note"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 25 }}
                                    value={member_form_state.address_note}
                                    onChange={(e) => onChange({ name: "address_note", value: e.target.value })}
                                    style={{marginBottom: 0}}
                                    disabled={attendance !== "1"}
                                />
                                ※「建物名・部屋番号１」に入りきらない場合は、続きをこちらにご入力ください。

                                <Typography variant="h6" gutterBottom component="div" sx={{ mt: 3 }}>
                                    お届け日
                                </Typography>
                                {"※消費期限の関係により、九州・沖縄・北海道の方へのお届けは開催当日のみとなります。"}
                                {"また、中国・四国・青森・秋田の方は、開催前日の午後以降のお届けとなります。"}
                                <SelectDeliveryDate
                                    required
                                    sx={{ m: 1 }}
                                    label="お届け日"
                                    variant="outlined"
                                    name="delivery_date"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={member_form_state.delivery_date}
                                    partyDate={party?.party_date}
                                    onChange={(e) => onChange({ name: "delivery_date", value: e.target.value })}
                                    disabled={disabledDeliveryDate || attendance !== "1"}
                                />

                                <Typography variant="h6" gutterBottom component="div" sx={{ mt: 3 }}>
                                    お届け時間
                                </Typography>
                                {"※お届け日が開催当日の場合、懇親会開始に間に合う時間帯をご指定ください。"}
                                <br/>
                                {"※交通事情等によりお届けが前後する場合がございます。予めご了承ください。"}
                                <SelectDeliveryTime
                                    required
                                    sx={{ m: 1 }}
                                    label="お届け時間"
                                    variant="outlined"
                                    name="delivery_time"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={member_form_state.delivery_time}
                                    noAM={noAM}
                                    onChange={(e) => onChange({ name: "delivery_time", value: e.target.value })}
                                    disabled={attendance !== "1"}
                                />

                                <Typography variant="h6" gutterBottom component="div" sx={{ mt: 3 }}>
                                    年齢のご確認*
                                </Typography>
                                {"※プレゼントドリンクをお選びいただくにあたり、年齢のご確認をさせていただいております。"}
                                {"未成年の酒類の購入や飲酒は日本の法律により固く禁じられています。"}<br/>
                                {"※選択されるプランによっては、プレゼントドリンクがつかないものもございます。"}
                                <FormControl>
                                    <RadioGroup
                                        required
                                        value={isUnder20}
                                        onChange={handleChangeAge}
                                    >
                                        <FormControlLabel
                                            value="0"
                                            label="20歳以上"
                                            control={<Radio name="age" color="primary" required />}
                                            disabled={attendance !== "1"}
                                        />
                                        <FormControlLabel
                                            value="1"
                                            label="20歳未満"
                                            control={<Radio name="age" color="primary" />}
                                            disabled={attendance !== "1"}
                                        />
                                    </RadioGroup>
                                </FormControl>

                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                                        プラン選択
                                    </Typography>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="flex-start"
                                    sx={{
                                        background: "#c7baaa3a",
                                        minHeight: "10rem",
                                        mb: 8,
                                        pt: 1,
                                        pb: 1,
                                    }}
                                >
                                    <MenuList menu_list={menu_data} select_button onSelect={selectMenu} onReselect={reselectMenu} />
                                </Grid>

                                {/* 選択プランのプレゼントドリンク本数が1本以上＆年齢選択済みの場合のみ表示 */}
                                {selectedMenu?.present_drink_number > 0 && isUnder20 !== null ? (
                                    <>
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="center"
                                        >
                                            <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                                                プレゼントドリンク選択
                                            </Typography>
                                        </Grid>
                                        <DrinkList 
                                            drink_list={drink_list} 
                                            drinkNumber={selectedMenu?.present_drink_number}
                                            onlyNonArcohol={isUnder20 === "1"}
                                            selectDrink={selectDrink} 
                                            reselectDrink={reselectDrink}
                                        />
                                    </>
                                ) : (
                                    ""
                                )}
                            </Grid>

                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    size="large"
                                    color="primary"
                                    sx={{ my: 8 }}
                                    type="submit"
                                >
                                    登録内容を確認
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
            </Grid>

            {/* PM-02 参加登録内容確認画面 */}
            <Grid style={{ display: member_form_state.confirmation && !member_form_state.complete ? '' : 'none' }}>
                <Typography variant="h2" align="center">
                    登録内容確認
                </Typography>
                <Container sx={{ mb: 5 }}>
                    <Grid
                        container
                        sx={{ pt: 3, mb: 1 }}
                        component="form"
                        onSubmit={ConfirmationSubmit} id="MemberFormConfirmation"
                    >
                        <ValueDisplay item="メールアドレス" value={member_form_state.email_address} />
                        <ValueDisplay item="参加登録" value={member_form_state.attendance === "1" ? "参加" : "キャンセル"} />
                        <ValueDisplay item="業務上氏名" value={member_form_state.business_name} />
                            
                        {member_form_state.attendance === "1" ? (
                            <>
                                <Typography variant="h6" gutterBottom component="div" sx={{ mt: 3, textAlign: "center", width: "100%" }}>
                                    送付先情報
                                </Typography>
                                <ValueDisplay item="お名前" value={`${member_form_state.last_name}　${member_form_state.first_name}`} />
                                <ValueDisplay item="お名前(カナ)" value={`${member_form_state.last_name_kana}　${member_form_state.first_name_kana}`} />
                                <ValueDisplay item="電話番号" value={member_form_state.phone} />
                                <ValueDisplay item="送付先住所" value={`${member_form_state.postal_code}\n    ${member_form_state.prefecture}\n    ${member_form_state.city}\n    ${member_form_state.address1}\n    ${member_form_state.address2}${member_form_state.address_note}`} />
                                <ValueDisplay item="お届け日" value={member_form_state.delivery_date} />
                                <Grid item xs={4}>
                                    <Typography variant="body2" gutterBottom component="div" textAlign="right">
                                        お届け時間：
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <SelectDeliveryTime value={member_form_state.delivery_time} disableSelect />
                                </Grid>
                                <ValueDisplay item="プラン" value={member_form_state.menu_name} />
                                {selectedMenu?.present_drink_number > 0 ?
                                    <ValueDisplay item="ドリンク" value={member_form_state.drink_group_name} />
                                    : ""
                                }
                            </>
                        ) : ""}
                        <Grid container sx={{display:'inline-flex', mt: 8}}>
                            <Grid item sx={{pr: "2rem", textAlign: "right", mb: 5}} xs={6}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    color="info"
                                    sx={{ width: "8rem" }}
                                    onClick={EditClick}
                                    disabled={disabled}
                                >
                                    修正する
                                </Button>
                            </Grid>
                            <Grid item sx={{pl: "2rem"}} xs={6}>
                                <Button
                                    form="MemberFormConfirmation"
                                    variant="contained"
                                    size="large"
                                    color="primary"
                                    sx={{ width: "8rem" }}
                                    type="submit"
                                    disabled={disabled}
                                >
                                    登録する
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Grid>

            {/* PM-03 参加登録完了画面 */}
            <Grid style={{ display: member_form_state.complete ? '' : 'none' }}>
                <Typography variant="h2" align="center">
                    登録完了
                </Typography>
                <Container>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                            参加登録を受付いたしました
                        </Typography>
                        <Typography variant="h6" gutterBottom component="div" sx={{ mt: 3 }}>
                            ※参加登録完了メールが届きます
                        </Typography>

                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            sx={{ border: "1px solid deepskyblue", maxWidth: "50rem", mt: 8, p: "1rem" }}
                        >
                            {"●登録内容の変更"}
                            <br/>
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                style={{padding: "1rem 0rem"}}
                            >
                                {"参加登録〆切"}
                                <br/>
                                {"　"}{formatDate(new Date(member_form_state.attendance_deadline_date), 'YYYY/MM/DD')}{"　16:00"}
                            </Grid>
                            <li>
                                {"〆切までであれば、何度でも変更が可能です。"}
                            </li>
                            <li>
                                {"変更やキャンセルの際は、再度同じフォームから送り直してください。"}
                            </li>
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
        </React.Fragment>
    );
};

const ValueDisplay = (props) => {
    const { item, value } = props;

    return (
        <>
            <Grid item xs={4}>
                <Typography variant="body2" gutterBottom component="div" textAlign="right">
                    {item}：
                </Typography>
            </Grid>
            <Grid item xs={8}>
                <Typography variant="body1" gutterBottom component="div" whiteSpace="pre-wrap" sx={{wordBreak: "break-all"}}>
                    {`    ${value}`}
                </Typography>
            </Grid>
        </>
    );
};

export default MemberForm;
